/* eslint-env jquery */
/* global Treehouse HoganTemplates */

import ReactivationHelper from "./reactivation_helper";

export default class CreditCardFormValidator {
  constructor() {
    this.creditCardValidator = new Treehouse.CreditCardValidator($("form#new_payment_method"));
    this.helper = new ReactivationHelper();
  }

  displayValidationErrors = (errors) => {
    const self = this;
    $.each(errors, (field, error) => {
      self.displayValidationError(field, error);
    });
  }

  displayValidationError = (field, error) => {
    const el = $(`input[name='${field}'`);
    el.siblings().andSelf().wrapAll("<div class='field_with_errors' />");
    const err = HoganTemplates["signup/field_error"].render({ error });
    el.after(err);
  }

  validateFields = () => {
    this.clearFormErrors();

    if (this.isPaypal()) {
      return true;
    }
    // If Stripe Payment Element is present, defer validation to Stripe
    if (document.getElementById("stripe-payment-element")) {
      return true;
    }
    if (this.isCC()) {
      this.creditCardValidator.validate();
      this.creditCardValidator.errors = $.extend(
        this.creditCardValidator.errors, this.validatePostalCode(),
      );
    }

    const errors = $.extend({}, this.creditCardValidator.errors);
    if (Object.keys(errors).length) {
      this.displayValidationErrors(errors);
      return false;
    }
    return true;
  }

  validatePostalCode = () => {
    const $postal = $("#payment_method_postal_code");
    if ($postal.length && this.helper.isEmpty($postal.val())) {
      return { "payment_method[postal_code]": "This is required" };
    }
    return {};
  }

  clearFormErrors = () => {
    this.creditCardValidator.clearErrors();
    this.unwrapErrors();
  }

  unwrapErrors = () => {
    $(".field_with_errors").each((index, element) => {
      const error = $(element);
      error.find("p.error-message").remove();
      error.children().unwrap();
    });
  }

  togglePaymentMethod = () => {
    if (this.isPaypal()) {
      $(".credit-card-chosen").hide();
      $(".on-file-selected").hide();
      $(".paypal-chosen").show();
    } else if (this.isCC()) {
      $(".paypal-chosen").hide();
      $(".on-file-selected").hide();
      $(".credit-card-chosen").show();
    } else if (this.isOnFile()) {
      $(".paypal-chosen").hide();
      $(".credit-card-chosen").hide();
      $(".on-file-selected").show();
    }
  }

  hideCCForm = () => {
    $(".credit-card-chosen").hide();
  }

  selectCCMethod = () => {
    $("input[name='payment_method_type'][value='credit_card']").prop("checked", true);
  }

  isPaypal = () => $("input[name='payment_method_type']").filter(":checked").val() === "paypal";

  isCC = () => $("input[name='payment_method_type']").filter(":checked").val() === "credit_card";

  isOnFile = () => $("input[name='payment_method_type']").filter(":checked").val() === "on_file";
}
